module.exports = __webpack_public_path__ + "img/main_logo.ace15abe.svg";